import { useState, useEffect } from "react"
import "./NotifierPopup.css"

function NotifierPopup({ notify, setNotify }){
    const [ timeoutRef, setTimeoutRef ] = useState(setTimeout(() => null))
    const [ beginDisable,  setBeginDisable] = useState(false)
    
    useEffect(() => {
        setTimeoutRef(setTimeout(() => setNotify({
            isActive: false,
            isSuccessful: undefined,
            message: undefined
        }), 5000))
        setTimeout(() => setBeginDisable(true), 4500)

        return () => clearTimeout(timeoutRef)
    }, [ notify ])

    return(
        <>
        {!notify.isSuccessful && <div className="black-notifier-background"></div>}
        <div className='absolute-notifier-wrapper'>
            <div className={`notifier-wrapper ${notify.isSuccessful ? 'success' : 'error'} ${beginDisable ? "disabled" : ""}`}>
                <h1>{notify.isSuccessful ? 'Sucesso' : 'Erro'}</h1>
                <p>{notify.message}</p>
                <button className={'close-button'} onClick={() => setNotify({
                    isActive: false,
                    isSuccessful: undefined,
                    message: undefined
                })}></button>
            </div>
        </div>
        </>
    )
}

export default NotifierPopup